import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";
import { VoucherCharsetEnum } from "../../data/enums";
import { RadiusProfileCommonSchema } from "../radius_profile/radius_profile.request";

export namespace ProductHotspotValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            price: baseVals.intMin(0, "Harga"),
            profit: baseVals.intMin(0, "Pendapatan Reseller"),
            dnsName: baseVals.string(),
            timeLimit: baseVals.intMin(60, "Batas Waktu", { unit: "detik" }),
            userLimit: baseVals.intMin(1, "Batas Pengguna", { unit: "orang" }),
            activeLimit: v.optional(baseVals.intMin(60, "Masa Aktif", { unit: "detik" })),
            lockUsersMAC: v.boolean(),
            charset: v.optional(v.picklist(VoucherCharsetEnum.values)),
            radiusProfile: RadiusProfileCommonSchema.create,
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            price: v.exactOptional(baseVals.intMin(0, "Harga")),
            profit: v.exactOptional(baseVals.intMin(0, "Pendapatan Reseller")),
            dnsName: v.exactOptional(baseVals.string()),
            timeLimit: v.exactOptional(baseVals.intMin(60, "Batas Waktu", { unit: "detik" })),
            userLimit: v.exactOptional(baseVals.intMin(1, "Batas Pengguna", { unit: "orang" })),
            activeLimit: v.exactOptional(baseVals.intMin(60, "Masa Aktif", { unit: "detik" })),
            lockUsersMAC: v.exactOptional(v.boolean()),
            charset: v.exactOptional(v.picklist(VoucherCharsetEnum.values)),
            radiusProfile: v.exactOptional(RadiusProfileCommonSchema.create),
        }),
    );
}
